<template>
<div class="w100 innerContent">
    <b-tabs class="small-tab">
        <b-tab :title="(relaysInfo.relays.relay1.name) ? relaysInfo.relays.relay1.name: 'AUX 1' " v-if="MachIsRelayUsed(4)">
            <relay :pool-id="poolId" :reel-num="1" v-on:onSave="onSave"></relay>
        </b-tab>
        <b-tab :title="(relaysInfo.relays.relay2.name) ? relaysInfo.relays.relay2.name: 'AUX 2' " v-if="MachIsRelayUsed(5)">
             <relay :pool-id="poolId" :reel-num="2" v-on:onSave="onSave" ></relay>
        </b-tab>
        <b-tab :title="(relaysInfo.relays.relay3.name) ? relaysInfo.relays.relay3.name: 'AUX 3' " v-if="MachIsRelayUsed(6)">
            <relay :pool-id="poolId" :reel-num="3" v-on:onSave="onSave"></relay>
        </b-tab>
        <b-tab :title="(relaysInfo.relays.relay4.name) ? relaysInfo.relays.relay4.name: 'AUX 4' " v-if="MachIsRelayUsed(7)">
            <relay :pool-id="poolId" :reel-num="4" v-on:onSave="onSave"></relay>
        </b-tab>
    </b-tabs>
</div>

</template>

<script>
import Relay from './utils/Relay.vue'


export default {
    name: 'Relays',
    components:{ 
        Relay
    },
    props: {
        poolId:Object,
    },
    mounted() {
        let fresh = JSON.parse(JSON.stringify(this.poolId));
        this.relaysInfo = fresh
    },
    data() {
        return {
            relaysInfo: {
                'relays':{
                    'relay1':{
                        'info':{
                            'manAutoTemp': 0,
                            'onoff': 0,
                            'freq': 0,
                            'freq2': 0,
                            'from': 0,
                            'from2': 0
                        }
                    },
                    'relay2':{
                        'info':{
                            'manAutoTemp': 0,
                            'onoff': 0,
                            'freq': 0,
                            'freq2': 0,
                            'from': 0,
                            'from2': 0
                        }
                    },
                    'relay3':{
                        'info':{
                            'manAutoTemp': 0,
                            'onoff': 0,
                            'freq': 0,
                            'freq2': 0,
                            'from': 0,
                            'from2': 0
                        }
                    },
                    'relay4':{
                        'info':{
                            'manAutoTemp': 0,
                            'onoff': 0,
                            'freq': 0,
                            'freq2': 0,
                            'from': 0,
                            'from2': 0
                        }
                    },
                }
    
            }
        }
    },
    methods:{
        onSave(original, reel, type, numReel) {
            this.$emit('onSave', original ,reel, 'relays', numReel);
        },
        MachIsRelayUsed(num){
            let relays = this.relaysInfo.relays
         try{
            if (relays.backwash.gpio == num) return 0;
            if (parseInt(relays.light.gpio) == num) return 0;
            if(this.poolId.filtration.hasHeat){
                if (parseInt(relays.filtration.heating.gpio) == num)return 0;
            }
            if(this.poolId.main.hasPH){
                if (parseInt(relays.ph.acid.gpio) == num)return 0; 
                if (parseInt(relays.ph.base.gpio) == num)return 0; 
            }
            if(this.poolId.main.hasRX){
                if (parseInt(relays.rx.gpio) == num) return 0;                    
            }
            if(this.poolId.main.hasCL){
                if (parseInt(relays.cl.gpio) == num) return 0;
            }
  
            if(this.poolId.main.hasCD){
                if (parseInt(relays.cd.gpio) == num) return 0;  
            }

            if(this.poolId.main.hasUV){
                 if (parseInt(relays.uv.gpio) == num) return 0;   
            }

            if(this.poolId.main.hasIO){
                if (parseInt(relays.io.gpio) == num) return 0;
            }
                return 1;
            } catch(error){
                
            }
        }
    }

}
</script>



// WEBPACK FOOTER //
// src/components/Relays.vue